import React from 'react';
import { useTheme } from 'styled-components';

import { SVGPropsType } from 'src/types';

function NoFavorites(props: SVGPropsType) {
    const { colors } = useTheme();
    const { onClick, style, className } = props;

    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M55 47.5C55 48.8261 54.4732 50.0979 53.5355 51.0355C52.5979 51.9732 51.3261 52.5 50 52.5H10C8.67392 52.5 7.40215 51.9732 6.46447 51.0355C5.52678 50.0979 5 48.8261 5 47.5V12.5C5 11.1739 5.52678 9.90215 6.46447 8.96447C7.40215 8.02678 8.67392 7.5 10 7.5H22.5L27.5 15H50C51.3261 15 52.5979 15.5268 53.5355 16.4645C54.4732 17.4021 55 18.6739 55 20V47.5Z"
                fill={colors.icon.default}
            />
            <path
                d="M40.1648 31.25L41.9925 34.9527L46.0797 35.5501L43.1222 38.4306L43.8202 42.5L40.1648 40.5777L36.5095 42.5L37.2074 38.4306L34.25 35.5501L38.3371 34.9527L40.1648 31.25Z"
                fill={colors.primary}
                stroke={colors.primary}
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default NoFavorites;
